module.exports = __webpack_public_path__ + "img/logo-white-wide-125.0cd416c0.png";